import {Typography} from '@mui/material';
import {AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {SendMessageModalProps} from './types';

const {modalInfo} = translations['pt-br'].privateFlow.help.sendYourMessage;

export function SendMessageModal({open, onBack}: SendMessageModalProps) {
	return (
		<AlertModal
			description={
				<Typography variant="body2" sx={{whiteSpace: 'pre-line'}}>
					{modalInfo.description.part1} <strong>{modalInfo.description.part2} </strong>
					{modalInfo.description.part3}
				</Typography>
			}
			headerTitle={modalInfo.titleModal}
			title={modalInfo.title}
			onClose={onBack}
			open={open}
			variant="info"
			slotProps={{
				paper: {
					style: {
						maxWidth: 328,
					},
				},
			}}
			buttonLabel={modalInfo.buttonGoBack}
		/>
	);
}
